import "./App.css";
import Header from "./components/Header";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <div className="App">
      <Header string="The main App"></Header>
    </div>
  );
}

export default App;
